/**
 * Shared constants for Builder v2. Kept in a separate file so that public page
 * components (header, footer, sections) can import them without loading
 * WebsiteBuilderV2Page (which pulls in GraphQL, Toast, and other app deps that
 * can cause "X is not a function" in the public pack bundle).
 */
export const DEFAULT_HIGHLIGHT_CLASSES = "rounded border-2 border-teal shadow-diffuse bg-teal/10"
